
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#fff","stroke-width":"3"}},[_c('circle',{attrs:{"cx":"16","cy":"16","r":"16","stroke":"none"}}),_c('circle',{attrs:{"cx":"16","cy":"16","r":"14.5"}})]),_c('path',{attrs:{"d":"M7 6h19v19H7z","fill":"none"}}),_c('path',{staticClass:"cls-3",attrs:{"d":"M15.034 20.033l.026.025a.436.436 0 00.358.139.482.482 0 00.355-.177l6.317-8.43a.485.485 0 00.109-.357.474.474 0 00-.174-.322.466.466 0 00-.352-.106.477.477 0 00-.325.173l-5.971 8.04-.117-.117-2.64-2.608a.493.493 0 00-.679 0 .48.48 0 000 .68z","stroke":"#fff","fill":"#fff","stroke-width":".3"}})])
          )
        }
      }
    